import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"

import Button from "components/ui/Button"
import List from "components/ui/InfoList"
import Title from "components/ui/ModalTitle"
import { formatMoney } from "helpers/formatters"
import { ProductType } from "types"

type Props = {
  product: ProductType
  onBanklink: () => void
}

const NewPayment = ({ product, onBanklink }: Props) => {
  const { t } = useTranslation()

  const { price, product_type } = product

  // TODO: fetch date from api
  const items = [
    {
      label: t("features.payment.transfer.list.beneficiary.name"),
      value: "PlusPlus Baltic OÜ",
    },
    {
      label: t("features.payment.transfer.list.beneficiary.account"),
      value: "EE782200221084126844",
    },
    {
      label: t("features.payment.transfer.list.description.title"),
      value: t(`features.product.type.${product_type}.title`),
    },
    {
      label: t("features.payment.transfer.list.reference.number"),
      value: "",
    },
  ]

  return (
    <Container>
      <Title>{t("features.payment.form.title")}</Title>
      <Wrapper>
        <Amount variant="h1">{formatMoney(price)}</Amount>
        <List items={items} />
      </Wrapper>
      <Toggle onClick={onBanklink}>
        {t("features.payment.toggle.banklink")}
      </Toggle>
    </Container>
  )
}

export default NewPayment

const Container = styled(Box)(({ theme }) => ({
  marginTop: "40px",
  [theme.breakpoints.down("lg")]: {
    margin: "0",
  },
}))

const Wrapper = styled(Box)`
  margin: 11px 0 35px 0;
`
const Amount = styled(Typography)`
  font-size: 3.5rem;
  font-weight: 400;
  height: 1.4375em;
  line-height: 1.4375em;
  margin: 0 0 34px 0;
  padding: 0;
  text-align: center;
`
const Toggle = styled(Button)`
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
`
